import { Button } from "@/components/ui/Button";
import classes from "./Form.module.scss";
import { useTranslation } from "@/hooks/useTranslation";
import { PersonalDetailsWithConfig } from "@/components/PersonalDetails";
import { ImperativeHandle } from "@/types/Form";
import { useImperativeHandle, useRef, useState } from "react";
import type { Ref } from "react";
import { dispatchEvent } from "@/utils/event-dispacher";
import { EventName } from "@/types/Events";
import { DetailsStep } from "@/types/Navigation";
import { useDonationFormStore } from "@/stores";

type FormStepYourDetailsProps = {
  onStepSubmit: () => void;
  ref?: Ref<ImperativeHandle>;
};

export function FormStepYourDetails(props: FormStepYourDetailsProps) {
  const { onStepSubmit, ref } = props;
  const t = useTranslation("_common");

  const personalDetailsRef = useRef<ImperativeHandle>(null);
  const [isValidating, setIsValidating] = useState(false);
  const personalDetails = useDonationFormStore(
    (state) => state.personalDetails,
  );

  useImperativeHandle(ref, () => ({
    validate: async () => {
      if (!personalDetailsRef.current) {
        return {
          isValid: true,
        };
      }

      return personalDetailsRef.current.validate();
    },
  }));

  const handleSubmit = async () => {
    setIsValidating(true);
    try {
      const validation = await personalDetailsRef.current?.validate();
      if (validation?.isValid) {
        onStepSubmit();
        dispatchEvent(EventName.STEP_SUBMIT, {
          step_name: DetailsStep.YourDetails,
          data: {
            forename: personalDetails.firstName,
            surname: personalDetails.lastName,
            email: personalDetails.email,
          },
        });
      }
    } finally {
      setIsValidating(false);
    }
  };

  return (
    <div>
      <PersonalDetailsWithConfig ref={personalDetailsRef} />

      <div className={classes.pagination}>
        <Button
          variant="outlined"
          size="large"
          isBusy={isValidating}
          onClick={handleSubmit}
        >
          {t("continue")}
        </Button>
      </div>
    </div>
  );
}
